/**
 *  订单管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>网站订单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row    border element-loading-text="拼命加载中" style="width: 100%;" >
       <el-table-column sortable align="center" prop="username" label="客户名称" width="60">
       </el-table-column>
      <el-table-column sortable align="center" prop="phone" label="手机号码" width="100">
      </el-table-column>
        <el-table-column sortable  align="center" prop="status" label="状态" width="150">

      </el-table-column>
        <el-table-column sortable  align="center" prop="create_time" label="创建时间" width="150">
      </el-table-column>
     <el-table-column align="center" label="操作" min-width="220">
        <template slot-scope="scope">
              <el-select  v-model="pro_status_value"  placeholder="请选择订单状态"  @change="changeStatus($event,scope.row.id)">
                  <el-option
                    v-for="(item,index) in statusList"
                    :key="index"
                    :label="item"
                    :value="index">
                  </el-option>
            </el-select>
        </template>
     </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

   


  </div>
</template>

<script>
import Vue from 'vue';
import { getBaiduOrder,ChangeBaiduOrder} from '../../api/order'
import Pagination from '../../components/Pagination'

export default {
  data() {
    return {
      statusList: ['未处理','已联系','安装完成'],
      pro_status_value:'',        
      formInline: {
        page: 1,
        limit: 10,
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },

    }
  },
  // 注册组件
  components: {
    Pagination
  },
 

  /**
   * 创建完毕
   */
  created() {
   this.getOrderList();
  
   
  },

 
  computed:{
    queryParam(){
    }
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    getOrderList(){
       getBaiduOrder().then(res=>{
        this.listData=res.data
      this.pageparm.total = res.count
    })
    },
    changeStatus(status,id){
      this.pro_status_value=""
      let params={status,id}
        ChangeBaiduOrder(params).then(res=>{
            if(res.code==200){
                this.getOrderList();
            }
        })

    },
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      if(this.isSearch){
          this.searchPage();
      }else{
        this.getdata(this.formInline)
      }
      
    },
},

    //点击名字弹出用户信息

   
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
  width: 1200px;
}
.userRole {
  width: 100%;
}
.seal{
	width: 60rpx;
	height: 60rpx;
	border: solid 6rpx #B4B4B4;
	border-radius: 100%;
	background-color: rgba(255, 255, 255, 0.8);
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
}
.seal-son{
	width: 45rpx;
	height: 45rpx;
	border: solid 2rpx #B4B4B4;
	border-radius: 100%;
	background-color: rgba(255, 255, 255, 0.8);
	position: relative;
}
.tips{

  font-size: 12px;
  color: #ccc;
  display: inline-block;
}


</style>

 
 


// WEBPACK FOOTER //
// src/views/order/baiduOrder.vue